import '../game.css';
import '../../app.css';
const React = require('react');
const assets = require('../../../assets').default;
// ============================

export default class informationComponent extends React.Component {
    renderInformationButtons() {
        const { soundEnable } = this.props;
        return (
            <div className="info-button-area">
                <div className="info-button">
                    <div className="btn-radius-solid" onClick={this.props.onPauseClick}>AFK</div>
                    <div className="btn-radius-solid" onClick={this.props.onSoundClick}>SOUND:{soundEnable ? "ON" : "OFF"}</div>
                </div>
            </div>
        )
    }

    renderInformation() {
        const { playerState: { playerName = "---", playerJobName = "---" } = {} } = this.props;
        const { gameState: { score = 0, arrivalStage = 0 } = {} } = this.props;
        const { time = 0 } = this.props;
        return (
            <div className="information">
                <div className="info-body-info-param">
                    <div className="info-body-info-param-name">
                        <div>{playerName}</div>
                        <div>{playerJobName}</div>
                    </div>
                    <div className="info-body-info-param-score">
                        <img src={assets.ScoreCoin} className="info-body-info-param-score-img" />
                        <div className="info-body-info-param-score-num">
                            {score}
                        </div>
                    </div>
                </div>

                <div className="info-body-info-status">
                    <div className="info-body-info-status-title">
                        stage
                    </div>
                    <div className="info-body-info-status-num">
                        {arrivalStage}
                    </div>
                    <div className="info-body-info-status-title">
                        time
                    </div>
                    <div className="info-body-info-status-num">
                        {time}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="dialog">
                <div className="dialog-header-bg">
                    <div className="dialog-header">基本情報</div>
                </div>
                <div className="dialog-contents">
                    <div className="dialog-row">
                        <div className="info-table-layout">
                            <div className="info-body-information">
                                {this.renderInformation()}
                            </div>
                            <div className="info-body-buttons">
                                {this.renderInformationButtons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
